import React, { Fragment } from 'react'
import { withTheme } from 'styled-components'
import WidgetLeaderSkeleton from '../../../Article/widgets/WidgetLeader/skeleton'
import SkeletonBlockBigArticle from '../../../../layouts/Blocks/views_article/BlockBigArticle/skeleton'
import SkeletonBlockThreeArticle from '../../../../layouts/Blocks/views_article/BlockThreeArticle/skeleton'
import SkeletonWidgetRackpaper from '../../../Paper/widgets/WidgetRackPaper/skeleton'
import WidgetDistrictNav from '../../widgets/WidgetDistrictNav/index'
import SkeletonBlockMostReadArticle from '../../../../layouts/Blocks/views_article/BlockMostReadArticle/skeleton'
import SkeletonPortraitItemArticle from '../../../Article/components/ItemArticle/views_default/SmallLandscapeItemArticle/skeleton'
import SkeletonWidgetInstagram from '../../../Social/widgets/WidgetInstagram/skeleton'
import SkeletonBlockFacebookAndArticle from '../../../../layouts/Blocks/views_article/BlockFacebookAndArticle/skeleton'
import SkeletonWidgetWeather from '../../../Weather/widgets/WidgetWeather/skeleton'

const PageHomeSkeleton = ({ adIds, layout, ...props }) => (
  <Fragment {...props}>
    {layout.map(({ name }, index) => {
      switch (name) {
        case 'leader_headline':
          return <WidgetLeaderSkeleton key={index + name} />
        case 'big_article':
          return (
            <SkeletonBlockBigArticle
              key={index + name}
              margin={
                props.theme.sizes.gapVertical + ' ' + props.theme.sizes.gapEdge + ' 0px ' + props.theme.sizes.gapEdge
              }
            />
          )
        case 'portrait_article':
          return (
            <SkeletonBlockThreeArticle
              key={index + name}
              margin={
                props.theme.sizes.gapVertical + ' ' + props.theme.sizes.gapEdge + ' 0px ' + props.theme.sizes.gapEdge
              }
            />
          )
        case 'rackpaper':
          return <SkeletonWidgetRackpaper key={index + name} margin={props.theme.sizes.gapVertical + ' 0px 0px 0px'} />
        case 'map':
          return <WidgetDistrictNav key={index + name} margin={props.theme.sizes.gapVertical + ' 0px 0px 0px'} />
        case 'mostread_article':
          return (
            <SkeletonBlockMostReadArticle
              key={index + name}
              margin={
                props.theme.sizes.gapVertical + ' ' + props.theme.sizes.gapEdge + ' 0px ' + props.theme.sizes.gapEdge
              }
            />
          )
        case 'landscape_article':
          return (
            <SkeletonPortraitItemArticle
              key={index + name}
              margin={
                props.theme.sizes.gapVertical + ' ' + props.theme.sizes.gapEdge + ' 0px ' + props.theme.sizes.gapEdge
              }
            />
          )
        case 'instagram':
          return <SkeletonWidgetInstagram key={index + name} margin={props.theme.sizes.gapVertical + ' 0px 0px 0px'} />
        case 'facebook_article':
          return (
            <SkeletonBlockFacebookAndArticle
              key={index + name}
              margin={
                props.theme.sizes.gapVertical + ' ' + props.theme.sizes.gapEdge + ' 0px ' + props.theme.sizes.gapEdge
              }
            />
          )
        case 'weather':
          return <SkeletonWidgetWeather key={index + name} margin={props.theme.sizes.gapVertical + ' 0px 0px 0px'} />
        default:
          return <Fragment key={index + name} />
      }
    })}
  </Fragment>
)

export default withTheme(PageHomeSkeleton)
